<app-projet-professionnel-list
  [participant]="participant"
></app-projet-professionnel-list>
